import { Badge, BadgeProps, styled } from '@mui/material';

const StyledBadge = styled(Badge)<BadgeProps>({
  '& .MuiBadge-badge': { transform: 'scale(1) translate(70%, -60%)' },
});

export default StyledBadge;
